import { processLatexViaUnified as r } from "@unified-latex/unified-latex";
import { unifiedLatexToPretext as o, xmlCompilePlugin as n } from "@pretextbook/unified-latex-to-pretext";
function x(e) {
  return ((t) => r().use(o, {
    producePretextFragment: !0
    //macroReplacements: myMacroReplacements,
    //environmentReplacements: ptxExtraEnvironmentReplacements,
  }).use(n).processSync({ value: t }))(e);
}
export {
  x as latexToPretext
};
